import React, { useEffect } from 'react';
import Article from "./Article4.png";
import { Container } from '@mui/material';

const headingStyle = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  color: '#221F1F',
  lineHeight: '36px',
};

const titleStyle = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '32px',
  color: '#31B9B5',
  lineHeight: '53.25px',
};

const paragraphStyle = {
  fontFamily: 'DM Sans',
  fontWeight: 400,
  fontSize: '16px',
  color: '#222222BF',
  lineHeight: '40.73px',
  textAlign: 'justify',
};

const ArticlePage5 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container maxWidth="xl" className="articleContainer">
      <div>
        <img src={Article} alt="Article 2" style={{ maxWidth: '100%',
    height: 'auto',
    marginTop: '50px' }} />
      </div>
      <div>
        <h3 style={titleStyle}>Document Verification Process</h3>
        <ol style={paragraphStyle}>
          <li>
            If your mortgage application is approved, it’s now time for closing. At this stage, a large stack of documents will be printed out and you’ll be invited to the title company (or attorney's office) for a closing meeting.
          </li>
          <li>
            One of the most important documents you’ll see at this meeting is your closing disclosure form. On this form, you’ll see a column showing the original estimated closing costs and final closing costs, along with another column indicating the difference if costs rose.
          </li>
          <li>
            Closing costs typically range from 2% to 5% of the home’s purchase price. Thus, if you buy a $200,000 house, your closing costs could range from $4,000 to $10,000. Closing fees vary depending on your state, loan type, and mortgage lender, so it’s important to pay close attention to these fees.
          </li>
          <li>
            If you see new fees that were not on the original loan estimate or notice that your closing costs are significantly higher, immediately seek clarification with your lender and/or real estate agent.
          </li>
          <li>
            If everything looks to be in order, you will sign to accept the mortgage and you will leave the office with the keys to your new home. Well done!
          </li>
          <li>
            At this point, a countdown begins. If no further action is taken, your mortgage will become active in three days' time. However, at this stage, you have the right to spend three days reviewing your documents to make sure everything is in order.
          </li>
          <li>
            You should compare your closing disclosure to the loan estimate you received in stage 4 above. Small changes, discrepancies, or typos are allowed, but if you see anything you don’t understand, you should seek clarification immediately.
          </li>
          <li>
            In addition, there are certain changes that can cause your mortgage agreement to be put on hold. This will happen if:
            <ul>
              <li>The APR on the loan changes by more than one-eighth of a percent (most fixed loans) or one-quarter of a percent (most adjustable rate loans).</li>
              <li>A prepayment penalty is added to the mortgage.</li>
              <li>There's a change of loan products (for example, a change from a fixed-rate loan to an adjustable-rate loan).</li>
            </ul>
          </li>
          <li>
            Assuming everything is in order, your mortgage will automatically go live after the three days are up.
          </li>
          <li>
            Typically, mortgage contracts give you the right to a final walk-through of the property at least 24 hours before your closing. You can use this visit to check that the previous tenant has vacated the property and that they have carried out any repairs that were required.
          </li>
        </ol>
      </div>
    </Container>
  );
};

export default ArticlePage5;
